module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket3-fill-ec6fb248.svg";